import { styled, TableContainer, TableContainerProps } from "@mui/material";

export const TableWrapper = styled(TableContainer)<TableContainerProps>(() => {
    return {
        "& th": {
            fontFamily: "Inter",
            fontWeight: 700,
            fontSize: "15px",
            color: "#2C352D",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
        },
        "& td": {
            fontFamily: "Inter",
            fontWeight: 300,
            fontSize: "14px",
            color: "#373737",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
        }
    }
})